// aws-config-attachments.js
import AWS from 'aws-sdk';

const REPORTS_BUCKET_NAME = 'boaz-joborder-reports';

const s3ReportsPDFUploader = new AWS.S3({
  accessKeyId: 'AKIAVXGA6A4KVI2M23NJ', // Replace with the new user's Access Key ID
  secretAccessKey: 'yqc/EGD0z/qi10bbR7dsb5VA0AGFxOKo3Qn8xeLe', // Replace with the new user's Secret Access Key
  region: 'ap-southeast-1' // Replace with your S3 bucket's region
});

export { s3ReportsPDFUploader, REPORTS_BUCKET_NAME };
